module.exports = __webpack_public_path__ + "assets/cGroup.915975c96d43d98986764b3b3485072d.png";